import React, { useEffect, useState } from "react";
import AbtcAvatar from "../../custom/Avatar";
import { Divider, ExpansionPanel, ExpansionPanelSummary, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import { getUserAccountList } from "../../actions/User";
import { FormattedMessage } from "react-intl";
import ExpansionPanelIcon from "../../custom/ExpansionPanelIcon";
import PropTypes from "prop-types";

const UserAccountList = ({ user, showMainAccount, title, defaultExpanded }) => {
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accountsData = await getUserAccountList(user.id);
        const accounts = accountsData.filter((a) => a.isSecondary).sort((a, b) => a?.taxResidence?.localeCompare(b?.taxResidence));
        if (showMainAccount) {
          const primaryAccount = accountsData.find((a) => !a.isSecondary);
          accounts.unshift(primaryAccount);
        }
        setAccounts(accounts);
      } catch (e) {
        setError(true);
      }
    };
    fetchData();
  }, [user.id, showMainAccount]);

  if (error) return <></>;

  return (
    <ExpansionPanel defaultExpanded={defaultExpanded}>
      <ExpansionPanelSummary expandIcon={<ExpansionPanelIcon />}>
        <Typography variant="body1" color="textPrimary">
          <FormattedMessage id={title} />
        </Typography>
      </ExpansionPanelSummary>
      <List>
        {accounts.length === 0 && (
          <Typography variant="body1" color="primary" align="center">
            <FormattedMessage id="app.user.secondary.notFound" />
          </Typography>
        )}
        {accounts?.map((a, key) => (
          <div key={key}>
            <ListItem alignItems="center">
              <ListItemAvatar>
                <AbtcAvatar imageUrl={a.photoUrl} disableLink />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography component="span" color="primary" variant="body1">
                    {a.name}
                  </Typography>
                }
                secondary={`${a.email} - ${a.taxResidence}`}
              />
              {!a.isSecondary && (
                <ListItemIcon>
                  <Typography variant="subtitle1" color="primary" style={{ background: "#0f0f0fff", padding: "2px 6px", borderRadius: 4 }}>
                    <FormattedMessage id="app.primary" />
                  </Typography>
                </ListItemIcon>
              )}
            </ListItem>
            {key < accounts.length - 1 && <Divider variant="middle" />}
          </div>
        ))}
      </List>
    </ExpansionPanel>
  );
};

UserAccountList.propTypes = {
  user: PropTypes.object.isRequired,
  showMainAccount: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  title: PropTypes.string,
};

UserAccountList.defaultProps = {
  showMainAccount: true,
  title: "app.user.secondary.accounts",
  defaultExpanded: false,
};

export default React.memo(UserAccountList);
